import { featureRoutes } from '../../index';
import { entityLink } from '../lib/entityLinks';

/** Link to a record's screen, or null when no registered screen shows it (yet). */
export function linkTo(
  entityType: string | null | undefined,
  entityId: string | null | undefined,
): string | null {
  // Read lazily: feature routes import this module, so they are only complete after start-up.
  return entityLink(
    entityType,
    entityId,
    featureRoutes.map((r) => r.path),
  );
}
